import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup,UntypedFormGroup,Validators } from '@angular/forms';
import  {Constant}  from '../../../constants/constants';
import {TranslateService} from '@ngx-translate/core';
import { ModalService } from 'src/app/common/modal/modal.service';
import { AppService } from 'src/app/app.service';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';


@Component({
    selector: 'app-form-field-textarea-v2',
    templateUrl: './form-field-textarea-v2.component.html',
    styleUrls: ['./form-field-textarea-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldTextareaV2Component implements OnInit {
  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  counter = 0;
  maxLen;
  lenValue = 0;
  validators = Validators;
  textareacss;
  message = "";
  enum=Constant;
  validationType: string = '';
  selfServiceConfig: boolean = false;
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  orderFormSubmitted: any;
  orderForm: any;

  initHeight;
  disabled: boolean = false;
  @ViewChild('textarea', { static: true, read: ElementRef }) textArea: ElementRef;

  constructor(private appService: AppService, private modalService: ModalService,public translate: TranslateService) {
  }

  ngOnInit() {
    if (this.configData.customFormFlag) {
      this.selfServiceConfig = false;
    }
    else if (sessionStorage.getItem('isSelfServiceConfig')) {
      this.selfServiceConfig = true;
    }
    this.disabled = this.configData.disabled;
    this.maxLen = this.configData.maxLength;
    this.lenValue = this.frmGroup.get(this.configData.name).value.length;
    this.counter = this.maxLen - this.lenValue;

    //passing Object
    if (this.configData['dynamicVisibility']) {
      if(this.configData['dynamicVisibility'].action == 'hidden'){
        this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
      }else
      if(this.configData['dynamicVisibility'].action == 'disabled'){
        this.disabled = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
      }
    }

    if(this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);
    
    if (this.frmGroup.get(this.configData.name).value && this.frmGroup.get(this.configData.name).value !== '' && this.frmGroup.get(this.configData.name).value.includes('%%LF%%')) {
      let cleanedData = this.frmGroup.get(this.configData.name).value.replace(/%%LF%%/g, '\n');
      this.frmGroup.get(this.configData.name).setValue(cleanedData)
    }
  }

  toggleDisable(bool) {
    this.disabled = bool;
  }

  valueChange() {
    if (this.frmGroup.get(this.configData.name).value) {
      this.frmGroup.get(this.configData.name).value.trim();
      if (this.frmGroup.get(this.configData.name).value && this.frmGroup.get(this.configData.name).value.trim() == null) {
        this.counter = this.maxLen;
      }
      else {
        this.counter = this.maxLen - this.frmGroup.get(this.configData.name).value.length;
      }
      /*code is commented due to we have set max limit by template 
      and after that we cannot able to type any char so this message is removed */

      // if (this.counter == 0) {
      //   this.message = "You have reached characters limit.";
      // }
    } else {
      this.counter = this.maxLen;
    }
  }

  autoResize(element) {
    let el = element as HTMLElement;
    this.initHeight = this.textArea.nativeElement.offsetHeight;
    el.style.height = this.initHeight + 'px';
    el.style.height = el.scrollHeight + 'px';
  }

  autoDefaultSize(element) {
    let el = element as HTMLElement;
    this.initHeight = this.textArea.nativeElement.offsetHeight;
    el.style.height = this.initHeight + 'px';
  }

  setValueToControl(value) {
    if (value != undefined) {
      this.frmGroup.get(this.configData.name).setValue(value);
    }
  }
  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']) {
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    // this.frmGroup.get(this.configData.name).reset(); // temp fix
    // this.frmGroup.get(this.configData.name).updateValueAndValidity();
    if(hidden === true)
      this.frmGroup.get(this.configData.name).setValue(''); // temp fix
  }

  fieldValueValidation(validations){
    validations.forEach((validataion: string | any) => {
      let element = (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
      if (element === "NoSpecialCharacter") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^((?![$<>?%&*#!~`]).|[\r\n])*$')));
      }
      if (element === "OTMRestrictedSpecialChars") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^((?![&<"]).)*$', 's')));
      }
    });
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);

  }
}
